import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useSelector } from 'react-redux';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Button,
  Popover,
  List,
  ListItem,
  ListItemIcon,
  Drawer,
  Box,
  Slide
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import PersonIcon from '@mui/icons-material/Person';
import { useLocation, Link } from 'react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import {
  Chat,
  LightMode,
  LocalHospital,
  Logout,
  People,
  Settings,
  SupervisedUserCircle,
  TagFaces
} from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Label from '../../common/type/Label';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router';
import {
  analyticsTrackEvent,
  getMappedClickEventPathName
} from '../../../utils/analytics/analytics-utils';
import Banner from '../../Banner/Banner';
import Tooltip from '@mui/material/Tooltip';
import '../../Banner/header.css';
const useStyles = makeStyles(theme => ({
  appBar: {
    background: '#fff !important',
    padding: '0 !important'
  },
  headerSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0'
  },
  menuButton: {
    marginRight: theme.spacing(2),
    color: '#2196F3',
    background: '#2196F3'
  },
  title: {
    flexGrow: 1,
    textAlign: 'center'
  },
  logo: {
    maxWidth: '100%',
    height: 'auto'
  },
  profileIcon: {
    backgroundColor: '##fff',
    marginRight: '8px',
    marginLeft: '-4px',
    fill: 'gray',
    borderRadius: '50%'
  }
}));

function HeaderSection() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [benefitsMenuOpen, setBenefitsMenuOpen] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isBenefits, setIsBenefits] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { instance } = useMsal();

  
  const handleMenuOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleBenefitsMenuOpen = event => {
    setBenefitsMenuOpen(event.currentTarget);
  };

  const handleBenefitsMenuClose = () => {
    setBenefitsMenuOpen(false);
  };
  const toggleMenuList = () => {
    isBenefits && handleSideMenuBenefits();
    setIsMenuOpen(!isMenuOpen);
  };
  const handleDrawerMenu = () => {
    setIsMenuOpen(false);
  };
  const handleSideMenuBenefits = () => {
    setIsBenefits(!isBenefits);
  };
  const handleLogout = () => {
    handleMenuClose();
    localStorage.removeItem('showProfileSetup');
    navigate('/');
    analyticsTrackEvent(getMappedClickEventPathName('profileTestLogout'));
    instance.logout();
  };
  const handleMenuClick = path => {
    /** Amplitude analytics implementation - Logging click events **/
    const eventName = `home_header_${getMappedClickEventPathName(
      path
    )}_clicked`;
    analyticsTrackEvent(eventName, { path, eventName });
  };
  const handleFindADoctor = () => {
    handleMenuClick(
      'https://dellchildrens.healthsparq.com/healthsparq/public/#/one/insurerCode=DCHP_I&brandCode=DCHP'
      
    );
    const url = 'https://dellchildrens.healthsparq.com/healthsparq/public/#/one/insurerCode=DCHP_I&brandCode=DCHP';
    window.open(url,'_blank');
     
  };
  const msalAccount = instance.getActiveAccount();
  const name = useSelector(
    state => state?.memberAccounts?.memberAccountsDetails?.self?.firstName
  ) || (msalAccount && msalAccount.name);
  const tenant = localStorage.getItem('tenantHandle');
  return (
    <AppBar className={classes.appBar} id="headerSection">
      <Toolbar className="headerRow">
        <IconButton
          edge="start"
          className={classes.menuButton}
          aria-label="menu"
          id="s-menu"
          onClick={toggleMenuList}
        >
          <MenuIcon className="s-icon" />
          <Typography variant="body1" className="s-menu">
            <Label id='menuText'/>
          </Typography>
        </IconButton>
        {isMenuOpen && (
          <Drawer
            anchor="left"
            variant="temporary"
            classes={{ paper: classes?.drawerPaper }}
            className="drawerForHeader"
            transitionDuration={500}
            open={isMenuOpen}
            onClose={() => setIsMenuOpen(false)}
          >
            <Slide direction="right" in={isMenuOpen}>
              <Box className="drawerBox">
                <Box className="drawerBoxContent menuDrawer">
                  <div>
                  <div className="hightlightOff">
                    <HighlightOffIcon onClick={() => setIsMenuOpen(false)} />
                  </div>
                  
                  <Link
                    onClick={() => {
                      handleDrawerMenu('home');
                      handleMenuClick('home');
                    }}
                    className="draw-links"
                    to="/"
                  >
                    <Label id="navHome" />
                  </Link>
                  <Link
                    onClick={handleSideMenuBenefits}
                    className="draw-links"
                    id='benefits-item-link'
                    to=""
                  >
                    <Label id="navBenefits" />  <div style={{'marginRight':'10px'}}>{isBenefits ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}</div>

                  </Link>
                  {isBenefits && (
                    <div>
                      <Link
                        to="/benefits-overview"
                        className="draw-sublinks"
                        id="overviewTab"
                        onClick={() => {
                          handleSideMenuBenefits();
                          handleMenuClick('overview');
                          setIsMenuOpen(false);
                        }}
                      >
                       <Label id='subnavOverview' />
                      </Link>
                      <Link
                        to="/benefits-whatscovered"
                        className="draw-sublinks"
                        id="whatsCoveredTab"
                        onClick={() => {
                          handleSideMenuBenefits();
                          handleMenuClick('whatscovered');
                          setIsMenuOpen(false);
                        }}
                      >
                      <Label id='subnavWhatsCovered' />
                      </Link>
                      <Link
                        to="/benefits-extrabenefits"
                        className="draw-sublinks"
                        id="extraBenefitsTab"
                        onClick={() => {
                          handleSideMenuBenefits();
                          handleMenuClick('valueaddedservices');
                          setIsMenuOpen(false);
                        }}
                      >
                        <Label id='subnavExtraBenefits' />
                      </Link>
                      <Link
                        className="draw-sublinks"
                        id="coveredMemberTab"
                        to="/benefits-coveredmembers"
                        onClick={() => {
                          handleSideMenuBenefits();
                          handleMenuClick('CoveredMembers');
                          setIsMenuOpen(false);
                        }}
                      >
                        <Label id="subnavCoveredMembers" />
                      </Link>
                      <Link
                        className="draw-sublinks"
                        id="priorAuthorizationsTab"
                        to="/benefits-priorauthorizations"
                        onClick={() => {
                          handleSideMenuBenefits();
                          handleMenuClick('PriorAuthorizations');
                          setIsMenuOpen(false);
                        }}
                      >
                       <Label id='subnavPriorAuthorizations' />
                      </Link>
                    </div>
                  )}

                  <Link
                    onClick={() => {
                      handleDrawerMenu('idcards');
                      handleMenuClick('idCards');
                    }}
                    className={isBenefits ?'draw-links draw-idcard-link': 'draw-links'}
                    to="/idCards"
                  >
                    <Label id="navIdCards" />
                  </Link>
                  <Link
                    onClick={() => {
                      handleDrawerMenu('claims');
                      handleMenuClick('claims');
                    }}
                    className="draw-links"
                    to="/claims"
                  >
                    <Label id="claims" />
                  </Link>
                  <a
                    onClick={() => {
                      setIsMenuOpen(false);
                      handleMenuClick(
                        'https://dellchildrens.healthsparq.com/healthsparq/public/#/one/insurerCode=DCHP_I&brandCode=DCHP'
                      );
                    }}
                    className="draw-links"
                    href="https://dellchildrens.healthsparq.com/healthsparq/public/#/one/insurerCode=DCHP_I&brandCode=DCHP"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Label id="navFindDoctor" />
                  </a>
                  <br />
                  <div className='sidebar-settings-list'><Banner /></div>
                  </div>
                  <div className="logoutBtn-section">
                    <Button
                      className="logoutBtn"
                      id="logoutBtn"
                      onClick={() => {
                        setIsMenuOpen(false);
                        handleMenuClick('testLogout');
                        handleLogout();
                      }}
                      to="/testLogout"
                    >
                      <Label id='logout' />
                    </Button>
                  </div>
                </Box>
              </Box>
            </Slide>
          </Drawer>
        )}
        <Typography variant="h6" className="logoSection" id="logoSection">
          <Link
            to="/"
            id="logo"
            onClick={() => {
              handleMenuClick('home');
            }}
          >
            <img
              src="/dchp/asce_dell_childrens_health_plan_logo.svg"
              alt="Logo"
              className={classes.logo}
            />
          </Link>
        </Typography>
        <div className="menu-items">
          <Button
            onClick={() => {
              handleMenuClick('home');
            }}
            className={location.pathname === '/' ? 'navitem active' : 'navitem'}
            component={Link}
            to="/"
          >
            <Label id="navHome" />
          </Button>
          <Button
             className={
              location.pathname === '/benefits-overview' ||
              location.pathname === '/benefits-whatscovered' ||
              location.pathname === '/benefits-extrabenefits' ||
              location.pathname === '/benefits-coveredmembers' ||
              location.pathname === '/benefits-priorauthorizations'
                ? 'navitem active'
                : 'navitem'
            }
            onClick={handleBenefitsMenuOpen}
            endIcon={<ExpandMoreIcon />}
          >
            <Label id="navBenefits" />
          </Button>
          <Popover
            open={Boolean(benefitsMenuOpen)}
            anchorEl={benefitsMenuOpen}
            onClose={handleBenefitsMenuClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left'
            }}
          >
            <List>
              <ListItem
                button
                component={Link}
                to="/benefits-overview"
                className={
                  location.pathname === '/benefits-overview'
                    ? 'active-submenu benefitsTabItem subMenuItem'
                    : 'benefitsTabItem subMenuItem'
                }
                id="overviewTab"
                onClick={() => {
                  handleBenefitsMenuClose();
                  handleMenuClick('overview');
                }}
              >
                <ListItemIcon>
                  <LightMode />
                </ListItemIcon>
                <Label id="subnavOverview" />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/benefits-whatscovered"
                className={
                  location.pathname === '/benefits-whatscovered'
                    ? 'active-submenu benefitsTabItem subMenuItem'
                    : 'benefitsTabItem subMenuItem'
                }
                id="whatsCoveredTab"
                onClick={() => {
                  handleBenefitsMenuClose();
                  handleMenuClick('whatscovered');
                }}
              >
                <ListItemIcon>
                  <LocalHospital />
                </ListItemIcon>
                <Label id="subnavWhatsCovered" />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/benefits-extrabenefits"
                className={
                  location.pathname === '/benefits-extrabenefits'
                    ? 'active-submenu benefitsTabItem subMenuItem'
                    : 'benefitsTabItem subMenuItem'
                }
                id="extraBenefitsTab"
                onClick={() => {
                  handleBenefitsMenuClose();
                  handleMenuClick('valueaddedservices');
                }}
              >
                <ListItemIcon>
                  <TagFaces />
                </ListItemIcon>
                <Label id='subnavExtraBenefits' />
              </ListItem>
              <ListItem
                button
                component={Link}
                className={
                  location.pathname === '/benefits-coveredmembers'
                    ? 'active-submenu benefitsTabItem subMenuItem'
                    : 'benefitsTabItem subMenuItem'
                }
                id="coveredMemberTab"
                to="/benefits-coveredmembers"
                onClick={() => {
                  handleBenefitsMenuClose();
                  handleMenuClick('CoveredMembers');
                }}
              >
                <ListItemIcon>
                  <People />
                </ListItemIcon>
                <Label id="subnavCoveredMembers"/>
              </ListItem>
              <ListItem
                button
                component={Link}
                className={
                  location.pathname === '/benefits-priorauthorizations'
                    ? 'active-submenu benefitsTabItem subMenuItem'
                    : 'benefitsTabItem subMenuItem'
                }
                id="priorAuthorizationsTab"
                to="/benefits-priorauthorizations"
                onClick={() => {
                  handleBenefitsMenuClose();
                  handleMenuClick('PriorAuthorizations');
                }}
              >
                <ListItemIcon>
                  <Chat />
                </ListItemIcon>
                <Label id="subnavPriorAuthorizations"
                />
              </ListItem>
            </List>
          </Popover>

          <Button
            onClick={() => {
              handleMenuClick('idcards');
            }}
            className={
              location.pathname === '/idCards' ? 'navitem active' : 'navitem'
            }
            component={Link}
            to="/idCards"
          >
            <img src="/assets/IdCardHeader.svg" id="idCardIcon" alt="idcard" />
            &nbsp; <Label id="navIdCards" />
          </Button>
          <Button
            onClick={() => {
              handleMenuClick('claims');
            }}
            className={
              location.pathname.includes('claims') ? 'navitem active' : 'navitem'
            }
            component={Link}
            to="/claims"
          >
            <img src="/dchp/DateRangefilled.svg" id="DateRangeIcon" alt="daterange"/>
            &nbsp; <Label id="claims" />
          </Button>
          <Button      className='findADoctorBTN'  onClick={() => {
               handleFindADoctor();
              }}>
            <span
              className="findadoctor navitem"
              // rel="noopener noreferrer"
       
            >
              <img src="/dchp/Searchfilled.svg" id="searchIcon" alt="searchfield"/>
              &nbsp; <Label id="navFindDoctor" />
            </span>
          </Button>
        </div>
        <div className="profileSection" id="profileSection">
        <Tooltip title="Open Settings" placement="bottom">
          <IconButton
            className={
        
                 'profileButton'
            }
            aria-label={name ? `${name}'s account` : 'account of current user'}
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenuOpen}
          >
            <span className="profiledetails">
              {' '}
              <AccountCircleIcon className={classes.profileIcon} />
              {name && (
                <span
                  className="profileButton"
                  id="profile"
                >
                  {name}
                </span>
              )}
            </span>
            <div className="profile-badge">
              <div className="badge-content">
              { name ?  name?.charAt(0).toUpperCase() : <PersonIcon />}
              </div>
            </div>
          </IconButton>

          </Tooltip>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            {tenant !== 'dchp' &&<MenuItem
              component={Link}
              to="/manageProfile"
              id="manageProfile"
              className="subMenuItem"
              onClick={() => {
                handleMenuClose();
                handleMenuClick('manageProfile');
              }}
            >
              <SupervisedUserCircle /> <Label id='manageProfile' />
            </MenuItem>}
            <MenuItem
              component={Link}
              to="/settings"
              id="profileSettings"
              className="subMenuItem"
              onClick={() => {
                handleMenuClose();
                handleMenuClick('settings');
              }}
            >
              <Settings /> <Label id='profileSettings' />
            </MenuItem>
            <MenuItem
              component={Link}
              to="/testLogout"
              id="logout"
              className="subMenuItem"
              onClick={() => {
                handleLogout();
                handleMenuClick('testLogout');
              }}
            >
              <Logout /> <Label id='logout' />
            </MenuItem>
          </Menu>
        </div>
      </Toolbar>
    </AppBar>
  );
}

export default HeaderSection;
